import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {LoginResponse} from '../_model/response/login.response';

@Injectable({
    providedIn: 'root'
})
export class DataService {

  public loginResponseSubject: BehaviorSubject<LoginResponse>;
  public loginResponseObservable: Observable<LoginResponse>;

  constructor() {
    this.loginResponseSubject = new BehaviorSubject<LoginResponse>(new LoginResponse());
    this.loginResponseObservable = this.loginResponseSubject.asObservable();
  }

  sendLoginResponseData(loginResponse: LoginResponse) {
    this.loginResponseSubject.next(loginResponse);
  }

  clear(){
    this.loginResponseSubject.next(null);
  }

}
